var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCocoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450.214 300.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIVI_Panels"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.304,167.181v65.213c-3.825,.131-7.824,.384-11.608,.761l.185-65.213c3.784-.377,7.598-.631,11.423-.761",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.881,167.943l-.185,65.213c-4.431,.441-8.821,1.051-13.138,1.83l.185-65.213c4.318-.779,8.708-1.389,13.138-1.83",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.742,169.772l-.185,65.213c-6.713,1.211-13.253,2.829-19.502,4.855l.185-65.213c6.25-2.026,12.789-3.645,19.502-4.855",
    fill: "#a27c5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.877,178.916l.076,.024v65.078c3.577-1.543,7.283-2.939,11.102-4.177l.185-65.213c-3.912,1.268-7.707,2.7-11.363,4.288Z",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.304,76.643c-66.885,1.053-136.246,15.731-185.906,43.436l130.447,58.861c16.128-7.016,36.239-10.968,55.459-11.759V76.643Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "55.376 184.818 55.376 116.299 195.81 178.257 195.731 244.018 55.376 184.818",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.261,151.908h0c0-1.343,1.09-1.957,2.431-1.371l8.902,3.889c1.33,.581,2.407,2.135,2.407,3.47h0c0,1.336-1.079,1.95-2.409,1.371l-8.902-3.871c-1.342-.583-2.43-2.146-2.429-3.489Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.154,148.022h0c1.335,.586,2.416,2.145,2.416,3.483l-.005,8.916c0,1.338-1.083,1.954-2.418,1.376h0c-1.337-.579-2.421-2.135-2.42-3.476l.004-8.934c0-1.341,1.086-1.952,2.423-1.366Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.252,172.533h0c0-1.343,1.09-1.965,2.431-1.39l8.901,3.813c1.33,.57,2.407,2.114,2.406,3.449h0c0,1.335-1.079,1.958-2.409,1.391l-8.9-3.796c-1.341-.572-2.429-2.125-2.429-3.467Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.144,168.592h0c1.335,.574,2.416,2.124,2.415,3.462l-.005,8.913c0,1.337-1.082,1.963-2.417,1.396h0c-1.336-.567-2.42-2.114-2.42-3.454l.004-8.931c0-1.34,1.086-1.96,2.422-1.385Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.243,193.152h0c0-1.342,1.089-1.973,2.43-1.41l8.899,3.738c1.33,.559,2.406,2.093,2.406,3.428h0c0,1.335-1.078,1.966-2.408,1.41l-8.899-3.72c-1.341-.561-2.429-2.104-2.428-3.446Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.133,189.154h0c1.335,.563,2.415,2.103,2.415,3.441l-.005,8.91c0,1.337-1.082,1.971-2.417,1.415h0c-1.336-.556-2.42-2.094-2.419-3.433l.004-8.928c0-1.34,1.085-1.969,2.422-1.405Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.327,142.348h0c0-1.355,1.109-1.97,2.474-1.373l9.061,3.958c1.354,.592,2.45,2.163,2.45,3.511h0c0,1.348-1.098,1.963-2.452,1.374l-9.061-3.94c-1.366-.594-2.473-2.174-2.473-3.53Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.342,138.454h0c1.359,.596,2.46,2.174,2.459,3.524l-.003,8.996c0,1.35-1.101,1.968-2.46,1.379h0c-1.361-.589-2.464-2.164-2.464-3.516l.003-9.015c0-1.353,1.105-1.965,2.465-1.368Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.322,163.159h0c0-1.355,1.109-1.978,2.474-1.393l9.06,3.882c1.354,.58,2.45,2.142,2.449,3.489h0c0,1.347-1.097,1.971-2.451,1.394l-9.059-3.864c-1.365-.582-2.473-2.153-2.473-3.508Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.335,159.208h0c1.359,.585,2.459,2.152,2.459,3.502l-.003,8.993c0,1.349-1.101,1.976-2.46,1.399h0c-1.36-.578-2.464-2.142-2.463-3.495l.003-9.011c0-1.352,1.105-1.974,2.465-1.388Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.316,183.963h0c0-1.354,1.108-1.987,2.474-1.414l9.058,3.805c1.354,.569,2.45,2.121,2.449,3.467h0c0,1.347-1.097,1.98-2.451,1.414l-9.058-3.787c-1.365-.571-2.473-2.132-2.472-3.486Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.329,179.955h0c1.359,.573,2.459,2.131,2.458,3.48l-.003,8.99c0,1.349-1.101,1.985-2.46,1.419h0c-1.36-.566-2.463-2.121-2.463-3.473l.003-9.008c0-1.352,1.104-1.982,2.465-1.408Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.998,132.616h0c0-1.368,1.128-1.983,2.519-1.376l9.225,4.03c1.379,.602,2.495,2.192,2.494,3.552h0c0,1.36-1.117,1.977-2.495,1.377l-9.224-4.011c-1.39-.605-2.518-2.204-2.518-3.571Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.138,128.714h0c1.384,.607,2.504,2.203,2.504,3.565v9.078c-.002,1.362-1.122,1.981-2.506,1.382h0c-1.385-.6-2.509-2.193-2.509-3.558v-9.096c.001-1.365,1.125-1.979,2.51-1.371Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.997,153.616h0c0-1.367,1.128-1.992,2.518-1.397l9.223,3.952c1.378,.591,2.494,2.171,2.494,3.53h0c0,1.359-1.117,1.985-2.495,1.397l-9.223-3.933c-1.39-.593-2.518-2.182-2.518-3.549Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.135,149.656h0c1.383,.595,2.504,2.181,2.503,3.543v9.075c-.002,1.362-1.122,1.99-2.505,1.402h0c-1.385-.588-2.508-2.171-2.508-3.536v-9.093c.001-1.365,1.125-1.987,2.51-1.392Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.995,174.609h0c0-1.367,1.128-2.001,2.518-1.417l9.221,3.874c1.378,.579,2.494,2.149,2.494,3.508h0c0,1.359-1.116,1.994-2.494,1.418l-9.221-3.855c-1.39-.581-2.517-2.16-2.517-3.527Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.133,170.591h0c1.383,.584,2.503,2.16,2.503,3.521v9.071c-.002,1.361-1.122,1.998-2.505,1.423h0c-1.385-.576-2.508-2.15-2.508-3.514v-9.09c.001-1.364,1.125-1.996,2.51-1.412Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.74,179.575h0c.001-1.308,1.036-1.917,2.309-1.361l8.45,3.691c1.263,.552,2.285,2.053,2.283,3.354h0c-.001,1.301-1.025,1.911-2.288,1.362l-8.449-3.674c-1.273-.554-2.305-2.063-2.304-3.372Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.285,175.715h0c1.267,.556,2.293,2.063,2.292,3.366l-.009,8.685c-.001,1.303-1.029,1.915-2.296,1.366h0c-1.269-.549-2.297-2.054-2.296-3.359l.009-8.702c.001-1.306,1.032-1.913,2.301-1.357Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.72,199.663h0c.001-1.308,1.035-1.925,2.308-1.38l8.448,3.62c1.263,.541,2.284,2.034,2.283,3.334h0c-.001,1.301-1.025,1.919-2.288,1.38l-8.448-3.603c-1.273-.543-2.305-2.044-2.304-3.351Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.265,195.75h0c1.267,.545,2.293,2.043,2.291,3.346l-.009,8.682c-.001,1.303-1.029,1.923-2.296,1.385h0c-1.268-.539-2.297-2.034-2.295-3.339l.009-8.699c.001-1.306,1.032-1.921,2.3-1.375Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.7,219.745h0c.001-1.307,1.035-1.933,2.308-1.399l8.447,3.548c1.263,.53,2.284,2.014,2.282,3.314h0c-.001,1.3-1.025,1.927-2.288,1.399l-8.447-3.531c-1.273-.532-2.305-2.024-2.303-3.331Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.244,215.779h0c1.267,.535,2.292,2.023,2.291,3.326l-.009,8.679c-.001,1.302-1.029,1.931-2.295,1.404h0c-1.268-.528-2.296-2.014-2.295-3.319l.009-8.696c.001-1.305,1.032-1.929,2.3-1.394Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.928,170.504h0c.001-1.32,1.053-1.93,2.349-1.364l8.597,3.755c1.285,.561,2.325,2.08,2.323,3.392h0c-.001,1.312-1.043,1.924-2.328,1.365l-8.596-3.738c-1.295-.563-2.346-2.09-2.345-3.41Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.587,166.635h0c1.29,.566,2.333,2.09,2.332,3.404l-.008,8.761c-.001,1.315-1.046,1.928-2.336,1.37h0c-1.291-.559-2.337-2.08-2.336-3.397l.007-8.778c.001-1.317,1.049-1.926,2.34-1.36Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.912,190.768h0c.001-1.319,1.053-1.938,2.348-1.383l8.595,3.683c1.285,.55,2.324,2.06,2.323,3.372h0c-.001,1.312-1.043,1.932-2.327,1.384l-8.595-3.666c-1.295-.552-2.345-2.07-2.344-3.389Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.569,186.846h0c1.289,.555,2.333,2.07,2.331,3.384l-.008,8.758c-.001,1.314-1.046,1.936-2.335,1.389h0c-1.291-.548-2.337-2.06-2.336-3.377l.007-8.775c.001-1.317,1.049-1.934,2.34-1.379Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.895,211.026h0c.001-1.319,1.053-1.946,2.348-1.402l8.594,3.61c1.284,.54,2.324,2.04,2.323,3.351h0c-.001,1.311-1.042,1.94-2.327,1.403l-8.594-3.593c-1.295-.541-2.345-2.05-2.344-3.368Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.552,207.049h0c1.289,.544,2.332,2.049,2.331,3.363l-.008,8.755c-.001,1.314-1.046,1.944-2.335,1.408h0c-1.29-.537-2.337-2.04-2.335-3.356l.007-8.772c.001-1.316,1.049-1.942,2.34-1.398Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.752,161.274h0c0-1.331,1.071-1.943,2.389-1.368l8.748,3.821c1.307,.571,2.365,2.107,2.364,3.431h0c0,1.324-1.061,1.937-2.368,1.368l-8.747-3.804c-1.318-.573-2.387-2.118-2.386-3.449Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.526,157.397h0c1.312,.576,2.374,2.117,2.373,3.443l-.006,8.838c0,1.326-1.064,1.941-2.376,1.373h0c-1.313-.569-2.379-2.107-2.378-3.436l.006-8.856c0-1.329,1.067-1.939,2.381-1.363Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.739,181.718h0c0-1.331,1.071-1.952,2.389-1.387l8.746,3.747c1.307,.56,2.365,2.087,2.364,3.41h0c0,1.323-1.06,1.945-2.368,1.387l-8.746-3.73c-1.318-.562-2.387-2.097-2.386-3.428Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.512,177.786h0c1.312,.564,2.374,2.097,2.373,3.422l-.006,8.835c0,1.326-1.064,1.949-2.376,1.392h0c-1.313-.558-2.378-2.087-2.377-3.415l.006-8.853c0-1.329,1.067-1.947,2.381-1.382Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.726,202.155h0c0-1.33,1.071-1.96,2.389-1.406l8.745,3.673c1.307,.549,2.365,2.066,2.364,3.389h0c0,1.323-1.06,1.953-2.367,1.407l-8.744-3.656c-1.318-.551-2.386-2.076-2.386-3.407Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.498,198.167h0c1.312,.553,2.373,2.076,2.372,3.402l-.006,8.832c0,1.325-1.064,1.957-2.375,1.411h0c-1.313-.547-2.378-2.066-2.377-3.394l.006-8.849c0-1.328,1.067-1.955,2.38-1.401Z",
    fill: "#aa7552"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M251.304,114.146c-6.535,.223-17.868,.657-24.333,1.301l.316-111.419C233.752,3.384,244.769,.223,251.304,0",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.287,4.028l-.316,111.419c-7.57,.754-15.07,1.796-22.448,3.126l.316-111.419c7.377-1.33,14.877-2.372,22.448-3.126",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.839,7.154l-.316,111.419c-11.47,2.068-22.643,4.834-33.321,8.296l.316-111.419c10.678-3.462,21.851-6.227,33.321-8.296",
    fill: "#a27c5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.518,15.45l-.316,111.419c-13.833,4.485-26.835,10.139-38.578,16.963-.724,.421-1.44,.844-2.149,1.27l.316-111.419c.709-.426,1.425-.85,2.149-1.27,11.743-6.824,24.745-12.478,38.578-16.963",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.304,49.74c-42.25,1.23-86.959,11.2-119.129,29.89-1.14,.66-1.79,1.54-1.79,1.54L54.925,55.31c5.38-3.82,11.14-7.51,17.26-11.07C120.345,16.26,188.024,1.51,251.304,0V49.74Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "55.376 118.539 55.376 55.429 130.555 81.35 130.555 150.041 55.376 118.539",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.969,85.03h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.697,80.966h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.969,104.094h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.697,100.03h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.969,123.158h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.697,119.094h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.683,78.036h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.412,73.972h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.683,97.1h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.412,93.036h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.683,116.164h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.412,112.1h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.398,71.041h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.126,66.978h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.398,90.105h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.126,86.042h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.398,109.169h0c0-1.241,1.061-1.882,2.369-1.431l8.719,3.006c1.308,.451,2.369,1.823,2.369,3.064h0c0,1.241-1.061,1.882-2.369,1.431l-8.719-3.006c-1.308-.451-2.369-1.823-2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.126,105.106h0c1.308,.451,2.369,1.823,2.369,3.064v8.272c0,1.241-1.061,1.882-2.369,1.431h0c-1.308-.451-2.369-1.823-2.369-3.064v-8.272c0-1.241,1.061-1.882,2.369-1.431Z",
    fill: "#aa7552"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.835,167.181v65.213c3.825,.131,7.824,.384,11.608,.761l-.185-65.213c-3.784-.377-7.598-.631-11.423-.761",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.258,167.943l.185,65.213c4.431,.441,8.821,1.051,13.138,1.83l-.185-65.213c-4.318-.779-8.708-1.389-13.138-1.83",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.397,169.772l.185,65.213c6.713,1.211,13.253,2.829,19.502,4.855l-.185-65.213c-6.25-2.026-12.789-3.645-19.502-4.855",
    fill: "#a27c5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.262,178.916l-.076,.024v65.078c-3.577-1.543-7.283-2.939-11.102-4.177l-.185-65.213c3.912,1.268,7.707,2.7,11.363,4.288Z",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.835,76.643c66.885,1.053,136.246,15.731,185.906,43.436l-130.447,58.861c-16.128-7.016-36.239-10.968-55.459-11.759V76.643Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "449.763 184.818 449.763 116.299 309.329 178.257 309.408 244.018 449.763 184.818",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.878,151.908h0c0-1.343-1.09-1.957-2.431-1.371l-8.902,3.889c-1.33,.581-2.407,2.135-2.407,3.47h0c0,1.336,1.079,1.95,2.409,1.371l8.902-3.871c1.342-.583,2.43-2.146,2.429-3.489Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.985,148.022h0c-1.335,.586-2.416,2.145-2.416,3.483l.005,8.916c0,1.338,1.083,1.954,2.418,1.376h0c1.337-.579,2.421-2.135,2.42-3.476l-.004-8.934c0-1.341-1.086-1.952-2.423-1.366Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.887,172.533h0c0-1.343-1.09-1.965-2.431-1.39l-8.901,3.813c-1.33,.57-2.407,2.114-2.406,3.449h0c0,1.335,1.079,1.958,2.409,1.391l8.9-3.796c1.341-.572,2.429-2.125,2.429-3.467Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.995,168.592h0c-1.335,.574-2.416,2.124-2.415,3.462l.005,8.913c0,1.337,1.082,1.963,2.417,1.396h0c1.336-.567,2.42-2.114,2.42-3.454l-.004-8.931c0-1.34-1.086-1.96-2.422-1.385Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.896,193.152h0c0-1.342-1.089-1.973-2.43-1.41l-8.899,3.738c-1.33,.559-2.406,2.093-2.406,3.428h0c0,1.335,1.078,1.966,2.408,1.41l8.899-3.72c1.341-.561,2.429-2.104,2.428-3.446Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.006,189.154h0c-1.335,.563-2.415,2.103-2.415,3.441l.005,8.91c0,1.337,1.082,1.971,2.417,1.415h0c1.336-.556,2.42-2.094,2.419-3.433l-.004-8.928c0-1.34-1.085-1.969-2.422-1.405Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420.812,142.348h0c0-1.355-1.109-1.97-2.474-1.373l-9.061,3.958c-1.354,.592-2.45,2.163-2.45,3.511h0c0,1.348,1.098,1.963,2.452,1.374l9.061-3.94c1.366-.594,2.473-2.174,2.473-3.53Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.797,138.454h0c-1.359,.596-2.46,2.174-2.459,3.524l.003,8.996c0,1.35,1.101,1.968,2.46,1.379h0c1.361-.589,2.464-2.164,2.464-3.516l-.003-9.015c0-1.353-1.105-1.965-2.465-1.368Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420.817,163.159h0c0-1.355-1.109-1.978-2.474-1.393l-9.06,3.882c-1.354,.58-2.45,2.142-2.449,3.489h0c0,1.347,1.097,1.971,2.451,1.394l9.059-3.864c1.365-.582,2.473-2.153,2.473-3.508Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.804,159.208h0c-1.359,.585-2.459,2.152-2.459,3.502l.003,8.993c0,1.349,1.101,1.976,2.46,1.399h0c1.36-.578,2.464-2.142,2.463-3.495l-.003-9.011c0-1.352-1.105-1.974-2.465-1.388Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420.823,183.963h0c0-1.354-1.108-1.987-2.474-1.414l-9.058,3.805c-1.354,.569-2.45,2.121-2.449,3.467h0c0,1.347,1.097,1.98,2.451,1.414l9.058-3.787c1.365-.571,2.473-2.132,2.472-3.486Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.81,179.955h0c-1.359,.573-2.459,2.131-2.458,3.48l.003,8.99c0,1.349,1.101,1.985,2.46,1.419h0c1.36-.566,2.463-2.121,2.463-3.473l-.003-9.008c0-1.352-1.104-1.982-2.465-1.408Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.141,132.616h0c0-1.368-1.128-1.983-2.519-1.376l-9.225,4.03c-1.379,.602-2.495,2.192-2.494,3.552h0c0,1.36,1.117,1.977,2.495,1.377l9.224-4.011c1.39-.605,2.518-2.204,2.518-3.571Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.001,128.714h0c-1.384,.607-2.504,2.203-2.504,3.565v9.078c.002,1.362,1.122,1.981,2.506,1.382h0c1.385-.6,2.509-2.193,2.509-3.558v-9.096c-.001-1.365-1.125-1.979-2.51-1.371Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.142,153.616h0c0-1.367-1.128-1.992-2.518-1.397l-9.223,3.952c-1.378,.591-2.494,2.171-2.494,3.53h0c0,1.359,1.117,1.985,2.495,1.397l9.223-3.933c1.39-.593,2.518-2.182,2.518-3.549Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.003,149.656h0c-1.383,.595-2.504,2.181-2.503,3.543v9.075c.002,1.362,1.122,1.99,2.505,1.402h0c1.385-.588,2.508-2.171,2.508-3.536v-9.093c-.001-1.365-1.125-1.987-2.51-1.392Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.144,174.609h0c0-1.367-1.128-2.001-2.518-1.417l-9.221,3.874c-1.378,.579-2.494,2.149-2.494,3.508h0c0,1.359,1.116,1.994,2.494,1.418l9.221-3.855c1.39-.581,2.517-2.16,2.517-3.527Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.006,170.591h0c-1.383,.584-2.503,2.16-2.503,3.521v9.071c.002,1.361,1.122,1.998,2.505,1.423h0c1.385-.576,2.508-2.15,2.508-3.514v-9.09c-.001-1.364-1.125-1.996-2.51-1.412Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.399,179.575h0c-.001-1.308-1.036-1.917-2.309-1.361l-8.45,3.691c-1.263,.552-2.285,2.053-2.283,3.354h0c.001,1.301,1.025,1.911,2.288,1.362l8.449-3.674c1.273-.554,2.305-2.063,2.304-3.372Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.853,175.715h0c-1.267,.556-2.293,2.063-2.292,3.366l.009,8.685c.001,1.303,1.029,1.915,2.296,1.366h0c1.269-.549,2.297-2.054,2.296-3.359l-.009-8.702c-.001-1.306-1.032-1.913-2.301-1.357Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.419,199.663h0c-.001-1.308-1.035-1.925-2.308-1.38l-8.448,3.62c-1.263,.541-2.284,2.034-2.283,3.334h0c.001,1.301,1.025,1.919,2.288,1.38l8.448-3.603c1.273-.543,2.305-2.044,2.304-3.351Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.874,195.75h0c-1.267,.545-2.293,2.043-2.291,3.346l.009,8.682c.001,1.303,1.029,1.923,2.296,1.385h0c1.268-.539,2.297-2.034,2.295-3.339l-.009-8.699c-.001-1.306-1.032-1.921-2.3-1.375Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M335.439,219.745h0c-.001-1.307-1.035-1.933-2.308-1.399l-8.447,3.548c-1.263,.53-2.284,2.014-2.282,3.314h0c.001,1.3,1.025,1.927,2.288,1.399l8.447-3.531c1.273-.532,2.305-2.024,2.303-3.331Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.895,215.779h0c-1.267,.535-2.292,2.023-2.291,3.326l.009,8.679c.001,1.302,1.029,1.931,2.295,1.404h0c1.268-.528,2.296-2.014,2.295-3.319l-.009-8.696c-.001-1.305-1.032-1.929-2.3-1.394Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.211,170.504h0c-.001-1.32-1.053-1.93-2.349-1.364l-8.597,3.755c-1.285,.561-2.325,2.08-2.323,3.392h0c.001,1.312,1.043,1.924,2.328,1.365l8.596-3.738c1.295-.563,2.346-2.09,2.345-3.41Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.552,166.635h0c-1.29,.566-2.333,2.09-2.332,3.404l.008,8.761c.001,1.315,1.046,1.928,2.336,1.37h0c1.291-.559,2.337-2.08,2.336-3.397l-.007-8.778c-.001-1.317-1.049-1.926-2.34-1.36Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.227,190.768h0c-.001-1.319-1.053-1.938-2.348-1.383l-8.595,3.683c-1.285,.55-2.324,2.06-2.323,3.372h0c.001,1.312,1.043,1.932,2.327,1.384l8.595-3.666c1.295-.552,2.345-2.07,2.344-3.389Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.57,186.846h0c-1.289,.555-2.333,2.07-2.331,3.384l.008,8.758c.001,1.314,1.046,1.936,2.335,1.389h0c1.291-.548,2.337-2.06,2.336-3.377l-.007-8.775c-.001-1.317-1.049-1.934-2.34-1.379Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.243,211.026h0c-.001-1.319-1.053-1.946-2.348-1.402l-8.594,3.61c-1.284,.54-2.324,2.04-2.323,3.351h0c.001,1.311,1.042,1.94,2.327,1.403l8.594-3.593c1.295-.541,2.345-2.05,2.344-3.368Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.587,207.049h0c-1.289,.544-2.332,2.049-2.331,3.363l.008,8.755c.001,1.314,1.046,1.944,2.335,1.408h0c1.29-.537,2.337-2.04,2.335-3.356l-.007-8.772c-.001-1.316-1.049-1.942-2.34-1.398Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.387,161.274h0c0-1.331-1.071-1.943-2.389-1.368l-8.748,3.821c-1.307,.571-2.365,2.107-2.364,3.431h0c0,1.324,1.061,1.937,2.368,1.368l8.747-3.804c1.318-.573,2.387-2.118,2.386-3.449Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.613,157.397h0c-1.312,.576-2.374,2.117-2.373,3.443l.006,8.838c0,1.326,1.064,1.941,2.376,1.373h0c1.313-.569,2.379-2.107,2.378-3.436l-.006-8.856c0-1.329-1.067-1.939-2.381-1.363Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.4,181.718h0c0-1.331-1.071-1.952-2.389-1.387l-8.746,3.747c-1.307,.56-2.365,2.087-2.364,3.41h0c0,1.323,1.06,1.945,2.368,1.387l8.746-3.73c1.318-.562,2.387-2.097,2.386-3.428Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.627,177.786h0c-1.312,.564-2.374,2.097-2.373,3.422l.006,8.835c0,1.326,1.064,1.949,2.376,1.392h0c1.313-.558,2.378-2.087,2.377-3.415l-.006-8.853c0-1.329-1.067-1.947-2.381-1.382Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.413,202.155h0c0-1.33-1.071-1.96-2.389-1.406l-8.745,3.673c-1.307,.549-2.365,2.066-2.364,3.389h0c0,1.323,1.06,1.953,2.367,1.407l8.744-3.656c1.318-.551,2.386-2.076,2.386-3.407Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.641,198.167h0c-1.312,.553-2.373,2.076-2.372,3.402l.006,8.832c0,1.325,1.064,1.957,2.375,1.411h0c1.313-.547,2.378-2.066,2.377-3.394l-.006-8.849c0-1.328-1.067-1.955-2.38-1.401Z",
    fill: "#aa7552"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M253.835,114.146c6.535,.223,17.868,.657,24.333,1.301l-.316-111.419c-6.465-.644-17.482-3.804-24.017-4.028",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.852,4.028l.316,111.419c7.57,.754,15.07,1.796,22.448,3.126l-.316-111.419c-7.377-1.33-14.877-2.372-22.448-3.126",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.3,7.154l.316,111.419c11.47,2.068,22.643,4.834,33.321,8.296l-.316-111.419c-10.678-3.462-21.851-6.227-33.321-8.296",
    fill: "#a27c5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,15.45l.316,111.419c13.833,4.485,26.835,10.139,38.578,16.963,.724,.421,1.44,.844,2.149,1.27l-.316-111.419c-.709-.426-1.425-.85-2.149-1.27-11.743-6.824-24.745-12.478-38.578-16.963",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.835,49.74c42.25,1.23,86.959,11.2,119.129,29.89,1.14,.66,1.79,1.54,1.79,1.54l75.46-25.86c-5.38-3.82-11.14-7.51-17.26-11.07C384.794,16.26,317.115,1.51,253.835,0V49.74Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "449.763 118.539 449.763 55.429 374.584 81.35 374.584 150.041 449.763 118.539",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.17,85.03h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.442,80.966h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.17,104.094h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.442,100.03h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.17,123.158h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.442,119.094h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.455,78.036h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.727,73.972h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.456,97.1h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.727,93.036h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.456,116.164h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.727,112.1h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.741,71.041h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.013,66.978h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.741,90.105h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.013,86.042h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.741,109.169h0c0-1.241-1.061-1.882-2.369-1.431l-8.719,3.006c-1.308,.451-2.369,1.823-2.369,3.064h0c0,1.241,1.061,1.882,2.369,1.431l8.719-3.006c1.308-.451,2.369-1.823,2.369-3.064Z",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.013,105.106h0c-1.308,.451-2.369,1.823-2.369,3.064v8.272c0,1.241,1.061,1.882,2.369,1.431h0c1.308-.451,2.369-1.823,2.369-3.064v-8.272c0-1.241-1.061-1.882-2.369-1.431Z",
    fill: "#aa7552"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.945,180.71c-2.51,1.2-4.94,2.49-7.28,3.85-19.73,11.46-29.7,26.42-29.94,41.44H.185c.11-38.05,24.79-76.01,74.11-105.27l121.65,59.98Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.185,
    y: 225.377,
    width: 158.348,
    height: 74.931,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.608,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.518,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.608,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.518,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.608,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.518,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.76,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.67,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.76,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.67,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.76,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.67,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.911,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.821,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.911,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.821,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.911,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.821,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.086,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.996,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.086,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.996,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.086,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.996,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.238,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.148,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.238,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.148,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.238,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.148,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.39,
    y: 237.142,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3,
    y: 232.231,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.39,
    y: 259.777,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3,
    y: 254.866,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.39,
    y: 282.411,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.3,
    y: 277.501,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.145,83.95c-6.26,4.08-11.85,8.38-16.78,12.86-4.1,3.71-7.74,7.55-10.92,11.47-2.68,3.31-5.04,6.68-7.08,10.11-1.82,3.07-3.39,6.17-4.69,9.31-1.15,2.72-2.09,5.49-2.84,8.25v.08c-.45,1.7-.83,3.38-1.14,5.09v.04c-.56,3.14-.87,6.3-.93,9.46H.185c.09-31.39,16.91-62.73,50.5-89.17l1.66,.48,41.41,11.87,.74,.21,7.04,2.02,10.88,3.12,16.73,4.8Z",
    fill: "#dadd9e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.366,
    width: 84.676,
    height: 74.931,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.984,
    y: 161.131,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.894,
    y: 156.22,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.984,
    y: 183.765,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.894,
    y: 178.855,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.984,
    y: 206.4,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.894,
    y: 201.489,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.136,
    y: 161.131,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.046,
    y: 156.22,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.136,
    y: 183.765,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.046,
    y: 178.855,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.136,
    y: 206.4,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.046,
    y: 201.489,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.288,
    y: 161.131,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.198,
    y: 156.22,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.288,
    y: 183.765,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.198,
    y: 178.855,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.288,
    y: 206.4,
    width: 15.157,
    height: 5.337,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.198,
    y: 201.489,
    width: 5.337,
    height: 15.158,
    rx: 2.668,
    ry: 2.668,
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M129.145,83.95v64.51c-6.34,4.17-12,8.57-16.96,13.15l.18-64.8c4.93-4.48,10.52-8.78,16.78-12.86Z",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.365,96.81l-.18,64.8c-4.12,3.8-7.76,7.72-10.92,11.74l.18-65.07c3.18-3.92,6.82-7.76,10.92-11.47Z",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.445,108.28l-.18,65.07c-2.71,3.44-5.07,6.95-7.09,10.52l.19-65.48c2.04-3.43,4.4-6.8,7.08-10.11Z",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.365,118.39l-.19,65.48c-1.86,3.29-3.42,6.64-4.69,10.01l.19-66.18c1.3-3.14,2.87-6.24,4.69-9.31Z",
    fill: "#947155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.675,127.7l-.19,66.18c-1.23,3.27-2.17,6.58-2.84,9.91l.19-67.76v-.08c.75-2.76,1.69-5.53,2.84-8.25Z",
    fill: "#906e52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.835,136.03l-.19,67.76c-.67,3.35-1.06,6.72-1.15,10.09l.2-72.72v-.04c.31-1.71,.69-3.39,1.14-5.09Z",
    fill: "#8b6a50"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.495 213.88 84.676 224.296 84.676 149.366 85.712 139.829 85.495 213.88",
    fill: "#906e52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.945,180.715c-2.505,1.203-4.941,2.479-7.285,3.841-.424,.246-.843,.494-1.258,.743l-.185,65.213c.415-.249,.834-.497,1.258-.743,2.402-1.396,4.898-2.703,7.47-3.931v-65.123Z",
    fill: "#a77f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.403,185.3l-.185,65.213c-5.005,3.01-9.355,6.251-13.05,9.662l.185-65.213c3.695-3.411,8.044-6.652,13.05-9.662",
    fill: "#a27c5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.353,194.962l-.185,65.213c-2.408,2.224-4.539,4.52-6.39,6.871l.185-65.213c1.852-2.352,3.982-4.648,6.39-6.871",
    fill: "#9e785a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.963,201.833l-.185,65.213c-1.586,2.015-2.968,4.07-4.146,6.156l.185-65.213c1.178-2.086,2.56-4.141,4.146-6.156",
    fill: "#997558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.816,207.989l-.185,65.213c-1.089,1.929-2.004,3.884-2.744,5.857l.185-65.213c.74-1.973,1.655-3.928,2.744-5.857",
    fill: "#947155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.072,213.847l-.185,65.213c-.72,1.919-1.275,3.855-1.664,5.8l.185-65.213c.39-1.945,.945-3.881,1.664-5.8",
    fill: "#906e52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.408,219.646l-.185,65.213c-.393,1.963-.619,3.936-.676,5.911l.185-65.213c.057-1.974,.282-3.947,.676-5.911",
    fill: "#8b6a50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.732,225.557l-.185,65.213c-.009,.302-.013,.603-.014,.905l.185-65.213c0-.302,.006-.603,.014-.905",
    fill: "#87674d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocoon);
export default __webpack_public_path__ + "static/media/cocoon.b8ac947f83ce073946084f33e796d492.svg";
export { ForwardRef as ReactComponent };